import { cn } from "@/lib/utils";
import type { TileCard } from "./model";

const VALUE_TONE: Record<TileCard["tone"], string> = {
  free: "text-[color:var(--avail-some-room-fg)]",
  over: "text-[color:var(--avail-over)]",
  neutral: "text-heading",
  gap: "text-[color:var(--avail-stretched-fg)]",
};

interface AvailabilityTilesProps {
  cards: readonly TileCard[];
  active: TileCard["id"] | null;
  onToggle: (id: TileCard["id"]) => void;
}

/** Four headline numbers. Each is a button that filters the grid to the people it counts. */
export function AvailabilityTiles({ cards, active, onToggle }: AvailabilityTilesProps) {
  return (
    <section
      aria-label="Summary"
      className="grid grid-cols-[repeat(auto-fit,minmax(230px,1fr))] gap-3"
    >
      {cards.map((card) => {
        const pressed = active === card.id;
        return (
          <button
            key={card.id}
            type="button"
            aria-pressed={pressed}
            onClick={() => onToggle(card.id)}
            className={cn(
              "flex cursor-pointer flex-col gap-1.5 rounded-lg border bg-card px-4 py-3.5 text-left outline-none focus-visible:ring-2 focus-visible:ring-ring",
              pressed ? "border-2 border-primary bg-accent" : "hover:bg-accent/50",
            )}
          >
            <span className="font-mono text-xs font-medium tracking-wider text-muted-foreground">
              {card.label}
            </span>
            <span className={cn("font-display text-2xl font-semibold", VALUE_TONE[card.tone])}>
              {card.value}
            </span>
            <span className="text-xs leading-snug text-muted-foreground">{card.sub}</span>
          </button>
        );
      })}
    </section>
  );
}
